<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Zgłoszenie integracji'" />
            <h5 class="mb-0 text-center" v-text="'Wybór serwisu'" />
        </template>

        <accordion header-class="drs-selected-tariff__header" :is-active="isDealerVisible">
            <template #header>
                <div class="text-left">
                    <h4 class="drs-selected-tariff__name mb-0" v-text="'Wybór serwisu'" />
                    <p
                        v-text="'Deklaracja wyboru serwisu do instalacji modułu System Kaucyjny'"
                        class="text-md text-primary mb-0"
                    />
                </div>
            </template>
            <template #expand-button>
                <the-btn
                    class="btn-outline-custom"
                    text="Wybierz sklepy"
                    :icon="isDealerVisible ? 'ArrowUp' : 'ArrowDown'"
                    @click="isDealerVisible = !isDealerVisible"
                />
            </template>
            <template #body>
                <service-shop
                    v-for="shop in selectedTariff.locations.filter(el => el.selected)"
                    :key="shop.id"
                    :shop="shop"
                    :expanded-shop-id="expandedShopId"
                    :tariff="selectedTariff"
                    @expand-shop="expandedShopId = expandedShopId === $event ? null : $event"
                />
            </template>
        </accordion>

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Wróć"
                @click="$store.dispatch('openModal', {
                    componentPath: 'drs/configuration/DealerWarning'
                })"
            />
            <the-btn
                v-tooltip="{
                    content: isSummaryDisabled && 'Uzupełnij pola obowiązkowe, aby przejść do kolejnego kroku'
                }"
                class="btn-secondary"
                text="Wyślij zgłoszenie"
                :disabled="isSummaryDisabled"
                :icon="creatingStatus ? 'Spinner' : ''"
                :loading-status="creatingStatus ? 'loading' : 'idle'"
                @click="createOrders"
            />
        </template>
    </ui-modal>
</template>

<script>
import { DEALER_SELECTIONS } from '@/utils/constants/drs/dealer-selections'
import ServiceShop from './ServiceShop.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    data: () => ({
        isDealerVisible: false,
        expandedShopId: null,
        creatingStatus: false
    }),

    computed: {
        ...mapGetters('drsTariffs', ['selectedTariff']),

        selectedShops() {
            return this.selectedTariff.locations.filter(el => el.selected)
        },

        isSummaryDisabled() {
            return this.selectedTariff.locations.some(shop => {
                if (shop.dealerSelection === DEALER_SELECTIONS.MANUAL && !shop.dealerText) {
                    /**
                     * If dealer selection is MANUAL, we require dealerText to be filled,
                     * so if it's empty, we return true to disable the summary button
                     */
                    return true
                }

                const deviceTypes = shop.deviceTypes || []

                if (deviceTypes.some(device => device.type === null || device.qty === 0)) {
                    // If deviceTypes array contains a device with type null or qty 0, disable summary button
                    return true
                }

                const countDevices = deviceTypes
                    .filter(device => device.type !== null)
                    .reduce((acc, device) => {
                        return acc + device.qty
                    }, 0)

                return countDevices === 0
            })
        }
    },

    methods: {
        ...mapActions('drsTariffs', ['createOrdersForSelectedShops']),
        ...mapActions('drsIntegrations', ['fetchIntegrations']),

        async createOrders() {
            if (this.isSummaryDisabled) {
                return
            }

            this.creatingStatus = true
            try {
                // Do createOrder for every shop at once
                await this.createOrdersForSelectedShops(this.selectedShops)

                this.goToOrdersSummary('ok')
            } catch(err) {
                this.goToOrdersSummary('error')
                console.error('Error creating orders:', err)
            } finally {
                this.creatingStatus = false
            }
        },
        goToOrdersSummary(status) {
            const title = status === 'ok' ? 'Zgłoszenie integracji' : 'Wystąpił błąd'

            const details = status === 'ok'
                ? `Przekazaliśmy Twoje zgłoszenie. Wkrótce skontaktuje się z
                    Tobą serwisant, aby ustalić termin instalacji.`
                : `Nie udało się zarejestrować zgłoszenia integracji.
                    Skontaktuj się z <a href="mailto:pomoc@kaucyjni.pl">pomoc@kaucyjni.pl</a>.`

            this.$store.dispatch('openModal', {
                componentPath: 'global/ui/ModalSummary',
                args: {
                    status,
                    details,
                    title,
                    closeModal: () => {
                        this.fetchIntegrations()
                        this.$store.dispatch('toggleModal', false)
                    }
                }
            })
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.isDealerVisible = true
            if (!this.expandedShopId) {
                this.expandedShopId = this.selectedShops[0].id
            }
        })
    },

    components: {
        ServiceShop
    }
}
</script>